module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/144-algeria-c7ff023e454a466eb45aada3a65d15b8.svg";